(function () {
  const NOTE_CLASS = 'custom-preorder-note';
  const PRODUCT_SELECTOR = '.AOV-MixMatch__ProductItem';
  const NAME_SELECTOR = '.AOV-MixMatch__ProductName';
  const IMAGE_SELECTOR = '.AOV-MixMatch__ProductImage';

  function normalizeText(str) {
    return String(str || '')
      .replace(/[“”„"]/g, '"')
      .replace(/[‘’]/g, "'")
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function extractBgImage(el) {
    if (!el) return '';
    const bg = el.style.backgroundImage || getComputedStyle(el).backgroundImage || '';
    const match = bg.match(/url\(["']?(.*?)["']?\)/i);
    return match ? match[1].replace(/^https?:/, '').trim() : '';
  }

  function htmlToText(html) {
    const div = document.createElement('div');
    div.innerHTML = html || '';
    return (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function extractLieferdatum(descriptionHtml) {
    const text = htmlToText(descriptionHtml);

    const patterns = [
      /versand\s+ab\s+(\d{1,2}\.\s*[A-Za-zÄÖÜäöüß]+\s*\d{4})/i,
      /lieferung\s+ab\s+(\d{1,2}\.\s*[A-Za-zÄÖÜäöüß]+\s*\d{4})/i,
      /versand\s+ab\s+(\d{1,2}\.\d{1,2}\.\d{2,4})/i,
      /lieferung\s+ab\s+(\d{1,2}\.\d{1,2}\.\d{2,4})/i
    ];

    for (const pattern of patterns) {
      const match = text.match(pattern);
      if (match && match[1]) {
        return match[1].replace(/\s+/g, ' ').trim();
      }
    }

    return null;
  }

  function isPreorderProduct(product) {
    const hasPreorderTag =
      Array.isArray(product?.tags) &&
      product.tags.some(tag => String(tag).toLowerCase() === 'preorder');

    const hasPreorderPlan =
      Array.isArray(product?.selling_plan_groups) &&
      product.selling_plan_groups.some(group =>
        String(group?.name || '').toLowerCase().includes('preorder')
      );

    return hasPreorderTag || hasPreorderPlan;
  }

  function removeExistingNote(container) {
    const existing = container.querySelector(`.${NOTE_CLASS}`);
    if (existing) existing.remove();
  }

  function addNote(nameEl, text) {
    const existing = nameEl.parentElement.querySelector(`.${NOTE_CLASS}`);
    if (existing) existing.remove();

    const note = document.createElement('div');
    note.className = NOTE_CLASS;
    note.textContent = text;
    note.style.fontSize = '12px';
    note.style.marginTop = '4px';
    note.style.color = '#b45309';
    note.style.fontWeight = '600';
    note.style.lineHeight = '1.35';
    note.style.textAlign = 'center';

    nameEl.insertAdjacentElement('afterend', note);
  }

  const discoveredProducts = [];
  const seenObjects = new WeakSet();
  const handleByTitleFromResources = new Map();
  let lookupPrepared = false;

  function looksLikeProduct(obj) {
    return obj &&
      typeof obj === 'object' &&
      typeof obj.title === 'string' &&
      typeof obj.handle === 'string' &&
      (
        typeof obj.url === 'string' ||
        Array.isArray(obj.images) ||
        typeof obj.featured_image === 'string'
      );
  }

  function walk(value, depth = 0) {
    if (!value || typeof value !== 'object') return;
    if (seenObjects.has(value)) return;
    seenObjects.add(value);
    if (depth > 4) return;

    if (Array.isArray(value)) {
      for (const v of value) walk(v, depth + 1);
      return;
    }

    if (looksLikeProduct(value)) {
      discoveredProducts.push({
        title: value.title,
        titleNorm: normalizeText(value.title),
        handle: value.handle,
        url: value.url || '',
        featured_image: (value.featured_image || '').replace(/^https?:/, ''),
        images: Array.isArray(value.images)
          ? value.images.map(img => String(img).replace(/^https?:/, ''))
          : [],
      });
    }

    for (const key of Object.keys(value)) {
      try {
        walk(value[key], depth + 1);
      } catch (_) {}
    }
  }

  async function prepareLookupData() {
    if (lookupPrepared) return;
    lookupPrepared = true;

    for (const key of Object.keys(window)) {
      try {
        walk(window[key], 0);
      } catch (_) {}
    }

    for (const entry of performance.getEntriesByType('resource')) {
      const url = entry.name || '';
      const match = url.match(/\/products\/([^/?#]+)\.js(?:[?#].*)?$/i);
      if (!match) continue;

      const handle = decodeURIComponent(match[1]);

      if ([...handleByTitleFromResources.values()].some(x => x.handle === handle)) continue;

      try {
        const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
        if (!res.ok) continue;
        const product = await res.json();
        handleByTitleFromResources.set(normalizeText(product.title), {
          handle: product.handle,
          product
        });
      } catch (_) {}
    }
  }

  function buildIndexes() {
    const discoveredByTitle = new Map();
    const discoveredByImage = new Map();

    for (const p of discoveredProducts) {
      if (!discoveredByTitle.has(p.titleNorm)) {
        discoveredByTitle.set(p.titleNorm, p);
      }

      const imgs = [p.featured_image, ...(p.images || [])].filter(Boolean);
      for (const img of imgs) {
        if (!discoveredByImage.has(img)) {
          discoveredByImage.set(img, p);
        }
      }
    }

    return { discoveredByTitle, discoveredByImage };
  }

  async function processItem(row, indexes) {
    if (!row?.item || !row?.nameEl || !row?.title) return;

    removeExistingNote(row.item);

    let handle = null;
    let product = null;

    const resourceMatch = handleByTitleFromResources.get(row.titleNorm);
    if (resourceMatch) {
      handle = resourceMatch.handle;
      product = resourceMatch.product;
    }

    if (!handle) {
      const byTitle = indexes.discoveredByTitle.get(row.titleNorm);
      if (byTitle) handle = byTitle.handle;
    }

    if (!handle && row.image) {
      const byImage = indexes.discoveredByImage.get(row.image);
      if (byImage) handle = byImage.handle;
    }

    if (!product && handle) {
      try {
        const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
        if (res.ok) {
          product = await res.json();
        }
      } catch (_) {}
    }

    if (!product || !isPreorderProduct(product)) return;

    const lieferdatum = extractLieferdatum(product.description);

    if (lieferdatum) {
      addNote(row.nameEl, `Vorbestellung, Lieferung ab ${lieferdatum}`);
    } else {
      addNote(row.nameEl, 'Vorbestellung, Lieferung später');
    }
  }

  async function scan() {
    const items = [...document.querySelectorAll(PRODUCT_SELECTOR)].map(item => {
      const nameEl = item.querySelector(NAME_SELECTOR);
      const imageEl = item.querySelector(IMAGE_SELECTOR);

      return {
        item,
        nameEl,
        title: nameEl?.textContent?.trim() || '',
        titleNorm: normalizeText(nameEl?.textContent || ''),
        image: extractBgImage(imageEl),
      };
    }).filter(x => x.nameEl && x.title);

    if (!items.length) return;

    await prepareLookupData();
    const indexes = buildIndexes();

    for (const row of items) {
      await processItem(row, indexes);
    }
  }

  let scanScheduled = false;

  function scheduleScan() {
    if (scanScheduled) return;
    scanScheduled = true;

    window.setTimeout(async () => {
      scanScheduled = false;
      try {
        await scan();
      } catch (err) {
        console.warn('AOV preorder note error:', err);
      }
    }, 150);
  }

  function initObserver() {
    const observer = new MutationObserver(() => {
      scheduleScan();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      scheduleScan();
      initObserver();
    });
  } else {
    scheduleScan();
    initObserver();
  }
})();